export class CookieManager {
    el;
    constructor(el) {
        this.el = el;
    }
}
